import { useState } from "react"
import { Bar } from "react-chartjs-2"
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Tooltip,
  Legend,
} from "chart.js"
import { Download } from "lucide-react"

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend)

export default function MessageActivityTimeline() {
  const [timeRange, setTimeRange] = useState("30")

  // Dummy hourly data (0h to 23h)
  const hours = Array.from({ length: 24 }, (_, i) => `${i}:00`)
  const dataPoints = hours.map(() => Math.floor(Math.random() * 100) + 10)

  const data = {
    labels: hours,
    datasets: [
      {
        label: 'Messages Sent',
        data: 0,
        // data: dataPoints,
        backgroundColor: '#3b82f6', // Blue
        borderRadius: 4,
      },
    ],
  }

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        callbacks: {
          label: (context) => `${context.raw} messages`,
        },
      },
    },
    scales: {
      x: {
        grid: { display: false },
        ticks: {
          maxTicksLimit: 12,
        },
      },
      y: {
        beginAtZero: true,
        ticks: {
          precision: 0,
        },
      },
    },
  }

  return (
    <div className="bg-white shadow-sm border border-gray-200 rounded-lg overflow-hidden">
      <div className="flex justify-between items-center p-4 border-gray-200 border-b">
        <div>
          <h3 className="font-medium">Message Activity Timeline</h3>
          <p className="text-gray-500 text-sm">Hourly distribution of messages</p>
        </div>
        <div className="flex items-center space-x-2">
          <select
            value={timeRange}
            onChange={(e) => setTimeRange(e.target.value)}
            className="px-3 py-1 border border-gray-300 focus:border-blue-500 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm"
          >
            <option value="1">Last 1 day</option>
            <option value="7">Last 7 days</option>
            <option value="30">Last 30 days</option>
          </select>
          <button className="hover:bg-gray-100 p-2 rounded-md text-gray-500 hover:text-gray-700">
            <Download className="w-4 h-4" />
          </button>
        </div>
      </div>

      <div className="p-4 h-64">
        <Bar data={data} options={options} />
      </div>

      <div className="bg-gray-50 p-4 border-gray-200 border-t text-gray-600 text-sm text-center">
        Showing data for last <span className="font-medium">{timeRange}</span> days
      </div>
    </div>
  )
}
